import { format } from "date-fns";
import { type GetListParams, type QueryFunctionContext } from "react-admin";

import { createApiClient } from "@/api";
import { DEFAULT_DATE_FORMAT } from "@/constants/date";
import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";

import { type RebillsFilter, type RebillsHydraMember } from "./types";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/rebill_analytics";

export const fetchRebillsListData = async ({
  filter = {},
  sort,
}: GetListParams) => {
  const typedFilter = filter as RebillsFilter;
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    [CLIENT_SEARCH_SOURCE]: _,
    clientApp,
    country,
    date_start: dateStart,
    date_end: dateEnd,
    ...restFilters
  } = typedFilter;

  const { data } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        group: typeof restFilters.group === "string" ? restFilters.group : "",
        client_app_id: clientApp?.split("/").pop(),
        country: country?.join(","),
        date_start: dateStart
          ? format(new Date(dateStart), DEFAULT_DATE_FORMAT)
          : "",
        date_end: dateEnd ? format(new Date(dateEnd), DEFAULT_DATE_FORMAT) : "",
        ...restFilters,
        tracker: "all",
        order_name: sort?.field ?? "group",
        order_type: sort?.order.toLowerCase() ?? "desc",
        pagination: false,
      },
    },
  });
  const hydraMember: RebillsHydraMember[] = data?.["hydra:member"] ?? [];
  return {
    data: hydraMember.map((item) => ({
      ...item,
      id: item["@id"]?.split("/").pop(),
    })),
    total: data?.["hydra:totalItems"] ?? 0,
  };
};

export const rebillsSchema = {
  list: async (params: GetListParams & QueryFunctionContext) =>
    fetchRebillsListData(params),
};
